import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as cookie from 'js-cookie'
import {
  COOKIES_AUTHORIZATION_TOKEN,
  HOMEPAGE_ROUTE,
}                                         from '@App/constantes'
import { AppState }                       from 'reducers'
import { userAppHasSegment, userHasRole } from '@App/helpers/user'
import ErrorBoundary                      from 'helpers/errorBoundary'
import menu                               from '@App/configs/menu'
import {
  RequireAuthParams,
  RequireAuthProps,
  RequireAuthState,
}                                         from './types'
import { fetchUser }                      from '@App/store/user'
import { logoutUser }                     from '@App/actions'

const requireAuth = ({ ComponentForRender, Layout, segment, role, menuIndex, Header }: RequireAuthParams) => {
  class AuthenticatedComponent extends React.Component<RequireAuthProps, RequireAuthState> {
    readonly state = {
      authenticated: false,
      currentPath: menu && menu[0],
    }

    componentDidMount() {
      const { user, currentApp, history } = this.props

      // check auth
      const authCookie = cookie.get(COOKIES_AUTHORIZATION_TOKEN)
      const redirect = location.search.split('callback_url=')[1]

      if (!cookie.get(process.env.COOKIES_AUTHORIZATION_TOKEN as string)) {
        return history.push(
          `/?redirect=${window.location.origin}/connect?callback_url=${redirect}`,
        )
      }

      if (!authCookie) {
        logoutUser()
        this.setState({ authenticated: false })
        return
      }

      fetchUser()

      // check segments
      if (!user || (role !== undefined && !userHasRole(user, role)) || (segment !== undefined && !userAppHasSegment(segment, currentApp))) {
        history.push(HOMEPAGE_ROUTE)
        return
      }

      return this.setState({ authenticated: true, currentPath: menu[menuIndex as number] })
    }

    render() {
      const { authenticated, currentPath } = this.state

      if (!authenticated) {
        return null
      }

      return Layout ? (
        <Layout
          background="white"
          currentPath={currentPath}
        >
          {Header}
          <ComponentForRender {...this.props} />
        </Layout>
      ) : (
          <ErrorBoundary>
            <ComponentForRender {...this.props} />
          </ErrorBoundary>
        )
    }
  }

  const mapStateToProps = (state: AppState) => {
    const {
      user,
    } = state

    return {
      currentApp: user && user.currentApp,
      user: user && user.user,
    }
  }

  const mapDispatchToProps = () => {
    return {}
  }

  const connectedComponent: any = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AuthenticatedComponent)

  return withRouter(connectedComponent)
}

export default requireAuth
